(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smoke-gone-mobile-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
 const input = event.target;
 if (!input.matches('.sg-reference-home input[name="sg_pack"]')) return;
 const section = input.closest('.sg-reference-home');
 section.querySelector('input[name="id"]').value = input.value;
 section.querySelector('.sg-ref-cart-price').textContent = input.dataset.price;
 const image = section.querySelector('.sg-ref-main-image');
 if (image && input.dataset.image) {
 image.src = input.dataset.image;
 image.removeAttribute('srcset');
 image.alt = input.dataset.title;
 }
});

  } catch(e) { console.error(e); }
})();
})();
